export default __webpack_public_path__ + "static/media/ic_folder_2.a5abf1ad.svg";